var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"5","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }